<template>
  <div>
		<div class="hero-wrapper">
			<div class="hero">
				<b-container>
					<div class="hero-inner">
						<h1 class="display-1">
							{{ $t('Start your journey and find your ideal hotel') }}
							<span class="subtitle">
								{{ $t('Try searching for a city, a specific hotel, or even a landmark!') }}
							</span>
						</h1>
						<Search :search="search" />
						<Partners/>
					</div>
				</b-container>
			</div>
			<div class="video-container">
				<video autoplay muted loop>
					<source src="../assets/video5.mp4" type="video/mp4">
				</video>
			</div>
		</div>
      <Blogs/>
   </div>
</template>

<script>
import dayjs from 'dayjs'

import Search from '@/components/ui/Search.vue'
import Partners from '@/components/ui/Partners.vue'
import Blogs from '@/components/ui/Blogs.vue'

export default {
	name: 'Home',
	components: {
		Search,
		Partners,
    Blogs,
	},
	data () {
		return {
			search: {
				place: {
					name: '',
					lat: '',
					lng: '',
				},
				date: {
					checkin: dayjs().format('YYYY-MM-DD'),
					checkout: dayjs().add(1, 'day').format('YYYY-MM-DD'),
				},
				occupation: {
					adults: 2,
					rooms: 1,
					children: 0,
					ages: [],
				},
				sort: 'recommended',
        currency: (this.$route.query.currency ? this.$route.query.currency : 'EUR'),
			},
			results: [],
		}
	},
	methods: {

	},
	mounted () {

	},
}
</script>

<style scoped>
  .video-container {
    position:fixed;
    top: 0;
    left: -1px;
    width: 100vw;
    min-height: 100vh;
    max-width:100%;
    overflow:hidden;
    z-index:-3;
  }
  .video-container > video {
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -2;
  }
  @media screen and (max-aspect-ratio: 1920/1080) {
    .video-container > video {
      height: 100%;
    }
  }
  @media screen and (min-aspect-ratio: 1920/1080) {
    .video-container > video {
      width: 100%;
    }
  }
  .subtitle{
    font-size:16px;
    display:block;
    margin-top:10px;
    margin-bottom:15px;
    font-weight:normal;
  }
  .hero{
    min-height:450px;
    position:relative;
    padding:15px;
    color:#fff;
  }
  .hero::before{
    content:"";
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-image: url('../assets/bg.jpg');
    background-size:cover;
    background-position:50% 50%;
    background-attachment:fixed;
    opacity:1;
    z-index:-3;
  }
  .hero::after{
    content:"";
    position:absolute;
    background-color:rgb(0,0,0);
    opacity:0.5;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index:-2;
  }
  .hero-inner{
    margin-top:50px;
  }
  .content-wrapper{
     background-color:#fff;
  }
</style>